// Copyright © 2021 Move Closer

import { Link } from '@movecloser/ui-core'

import {
  ModuleContent,
  ModuleDriver,
  ModuleWithVersion,
  Related,
  RelatedType,
  ResolvedLink,
  UnresolvedLink
} from '../../../contracts'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export interface ContactPersonModuleContent extends ModuleContent {
  /**
   * Array of less important links to render under the main CTA.
   */
  bottomLinks?: ResolvedLink[] | UnresolvedLink[]

  /**
   * Person's company.
   */
  company?: string

  /**
   * Person's image (profile photo).
   */
  image: Related<RelatedType.File> | null

  /**
   * Link that should be attached to the main CTA button.
   */
  mainLink: Link | UnresolvedLink | null

  /**
   * Person's name.
   */
  name: string

  /**
   * Person's job role.
   */
  role?: string

  /**
   * Person's region
   */
  region?: string
}

export enum ContactPersonModuleVersion {
  Basic = 'basic',
  WithBackground = 'with-background'
}

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export type ContactPersonModule = ModuleWithVersion<
  ContactPersonModuleContent,
  ModuleDriver.ContactPerson,
  ContactPersonModuleVersion
>
